import { computed, makeObservable } from 'mobx';

import { createModelSchema, primitive, list, object } from 'serializr';
import { optional, PolicyRule } from '@vromo/models';

import { SimulatedOfferRule } from '@vromo/models';

type ReasonsType = { [key: string]: boolean | null };

export class SimulatedOffer {
    job: number | null = null;
    vehicle: number | null = null;

    liveness: number | null = null; // Most recent GPS point

    vehicleAvailable: boolean | null = null;
    jobNotStarted: boolean | null = null; // Job was already started

    policyRules: PolicyRule[] = [];
    rules: SimulatedOfferRule[] = [];

    offered: boolean | null = null;
    recalled: boolean | null = null;
    returned: boolean | null = null;

    constructor() {
        makeObservable(this, {
            reasons: computed
        });
    }

    get reasons(): ReasonsType {
        return {
            vehicleAvailable: this.vehicleAvailable,
            liveness: !(this.liveness! < 0),
            jobNotStarted: this.jobNotStarted,
            rulesApplied: this.rules.reduce((prev: boolean, it) => it.offered || prev, false)
        };
    }
}

createModelSchema(SimulatedOffer, {
    job: optional(primitive()),
    vehicle: optional(primitive()),
    liveness: optional(primitive()),
    vehicleAvailable: optional(primitive()),
    jobNotStarted: optional(primitive()),
    policyRules: list(object(PolicyRule)),
    rules: list(object(SimulatedOfferRule)),
    offered: optional(primitive()),
    recalled: optional(primitive()),
    returned: optional(primitive())
});
